const seasonalCitiesOverview = [
  {
      "city": "New York City",
      "secondhome": "1200",
      "residents": " 775",
      "country": "USA"
  },
  {
      "city": "Los Angeles",
      "secondhome": "950",
      "residents": " 504",
      "country": "USA"
  },
  {
      "city": "London",
      "secondhome": "800",
      "residents": " 388",
      "country": "UK"
  },
  {
      "city": "The Hamptons",
      "secondhome": "700",
      "residents": " 30",
      "country": "USA"
  },
  {
      "city": "Miami",
      "secondhome": "650",
      "residents": " 165",
      "country": "USA"
  },
  {
      "city": "Dubai",
      "secondhome": "500",
      "residents": " 210",
      "country": "UAE"
  },
  {
      "city": "Palm Beach and West Palm Beach",
      "secondhome": "400",
      "residents": " 60",
      "country": "USA"
  },
  {
      "city": "Sydney",
      "secondhome": "350",
      "residents": " 198",
      "country": "Australia"
  },
  {
      "city": "Nice",
      "secondhome": "300",
      "residents": " 63",
      "country": "France"
  },
  {
      "city": "Napa",
      "secondhome": "250",
      "residents": " 28",
      "country": "USA"
  },
  {
      "city": "Golden Triangle, Algarve",
      "secondhome": "250",
      "residents": " 20",
      "country": "Portugal"
  },
  {
      "city": "Aspen",
      "secondhome": "200",
      "residents": " 6",
      "country": "USA"
  },
  {
      "city": "Jackson Hole",
      "secondhome": "200",
      "residents": " 8",
      "country": "USA"
  },
  {
      "city": "Cannes",
      "secondhome": "200",
      "residents": " 25",
      "country": "France"
  },
  {
      "city": "Lake Lugano",
      "secondhome": "200",
      "residents": " 30",
      "country": "Switzerland"
  },
  {
      "city": "Carmel-by-the-Sea",
      "secondhome": "200",
      "residents": " 35",
      "country": "USA"
  },
  {
      "city": "Mykonos (island)",
      "secondhome": "200",
      "residents": " 12",
      "country": "Greece"
  },
  {
      "city": "Boca Raton",
      "secondhome": "150",
      "residents": " 28",
      "country": "USA"
  },
  {
      "city": "Athens",
      "secondhome": "150",
      "residents": " 40",
      "country": "Greece"
  },
  {
      "city": "Lisbon",
      "secondhome": "150",
      "residents": " 37",
      "country": "Portugal"
  },
  {
      "city": "Florence",
      "secondhome": "150",
      "residents": " 28",
      "country": "Italy"
  },
  {
      "city": "Lake Como",
      "secondhome": "150",
      "residents": " 18",
      "country": "Italy"
  },
  {
      "city": "Saint Jean Cap Ferrat",
      "secondhome": "150",
      "residents": " 12",
      "country": "France"
  },
  {
      "city": "Saint Tropez",
      "secondhome": "150",
      "residents": " 15",
      "country": "France"
  },
  {
      "city": "Marbella",
      "secondhome": "150",
      "residents": " 14",
      "country": "Spain"
  },
  {
      "city": "Ibiza (island)",
      "secondhome": "150",
      "residents": " 10",
      "country": "Spain"
  },
  {
      "city": "Antibes",
      "secondhome": "150",
      "residents": " 15",
      "country": "France"
  },
  {
      "city": "Sanya",
      "secondhome": "100",
      "residents": " 5",
      "country": "China"
  },
  {
      "city": "Park City",
      "secondhome": "100",
      "residents": " 8",
      "country": "USA"
  },
  {
      "city": "Lake Tahoe",
      "secondhome": "100",
      "residents": " 15",
      "country": "USA"
  },
  {
      "city": "Naples",
      "secondhome": "100",
      "residents": " 24",
      "country": "USA"
  },
  {
      "city": "Sanremo",
      "secondhome": "100",
      "residents": " 10",
      "country": "Italy"
  },
  {
      "city": "Fort Lauderdale",
      "secondhome": "100",
      "residents": " 25",
      "country": "USA"
  },
  {
      "city": "Montecito",
      "secondhome": "100",
      "residents": " 30",
      "country": "USA"
  },
  {
      "city": "Rancho Santa Fe",
      "secondhome": "100",
      "residents": " 10",
      "country": "USA"
  },
  {
      "city": "Bodrum",
      "secondhome": "100",
      "residents": " 8",
      "country": "Türkiye"
  },
  {
      "city": "Cape Town",
      "secondhome": "100",
      "residents": " 25",
      "country": "South Africa"
  },
  {
      "city": "Rio de Janeiro",
      "secondhome": "100",
      "residents": " 35",
      "country": "Brazil"
  },
  {
      "city": "Marrakech",
      "secondhome": "100",
      "residents": " 10",
      "country": "Morocco"
  },
  {
      "city": "Porto Cervo",
      "secondhome": "100",
      "residents": " 5",
      "country": "Italy"
  }
];


export {seasonalCitiesOverview};